module.exports = __webpack_public_path__ + "static/media/miaou1.5d07fa74.mp3";